export default "__VITE_ASSET__CMo_fiKh__"